import Vue from 'vue';
import AccountFlyout, { AccountNavButton, AccountLink } from '@rei/account-flyout';
import { getUser } from '@rei/session';

const gNav = document.querySelector('.gnav');
const isWhiteNav = gNav !== null;

let isAccountMounted = false;

const accountEventBus = new Vue({});

let user = null;

if (isWhiteNav) {
  user = getUser()
    .then((userObj) => {
      user = userObj;
      if (user && user.isLoggedIn) {
        // eslint-disable-next-line no-new
        new Vue({
          el: '[data-ui="login-module-greeting"]',
          render(app) {
            return app(AccountNavButton);
          },
        });
      } else {
        // eslint-disable-next-line no-new
        new Vue({
          el: '[data-ui="login-module-greeting"]',
          render(app) {
            return app(AccountLink);
          },
        });
      }

      const accountToggleButton = document.querySelector("[data-ui='site-header-action-local-account']");
      const navbarWrapper = document.querySelector("[data-ui='site-navigation']");

      // Mount account and set event listeners, this function will only be executed if the account button
      // is hover or focused. Otherwise there is no need to mount component
      const mountAccount = () => {
        isAccountMounted = true;

        const data = {
          open: false,
        };

        // Insert <li> element next to account toggle button to render Account component
        accountToggleButton.parentNode.insertAdjacentHTML('afterEnd', `<li class="account-dropdown ${isWhiteNav && 'account-dropdown--white-nav'}"><div id="account-placement"></div></li>`);
        const accountDropdown = document.querySelector('.account-dropdown');

        // eslint-disable-next-line no-new
        new Vue({
          el: '#account-placement',
          data,
          mounted() {
            accountEventBus.$on('closed', this.handleClose);

            accountToggleButton.setAttribute('aria-expanded', 'false');
            accountToggleButton.setAttribute('aria-controls', 'account-bar');
            accountToggleButton.addEventListener('click', this.toggleButtonHandler);
            window.addEventListener('click', this.clickOutsideHandler, true);
          },
          beforeDestroy() {
            accountEventBus.$off('closed', this.handleClose);

            accountToggleButton.removeEventListener('click', this.toggleButtonHandler);
            window.removeEventListener('click', this.clickOutsideHandler, true);
          },
          methods: {
            toggle() {
              this.open = !this.open;
            },
            handleClose() {
              this.open = false;
              accountToggleButton.setAttribute('aria-expanded', 'false');
              navbarWrapper.style.overflowY = 'initial';
              accountToggleButton.focus();

              if (isWhiteNav) {
                gNav.setAttribute('data-account', 'false');
                document.body.classList.remove('no-scroll');
              }
            },
            toggleButtonHandler(event) {
              if (!isWhiteNav) {
                event.preventDefault();
                event.stopPropagation();
              }

              const { clientWidth } = window.document.body;

              this.toggle();
              document.body.classList.remove('sign-in-open');
              accountToggleButton.setAttribute('aria-expanded', this.open ? 'true' : 'false');
              navbarWrapper.style.overflowY = this.open && clientWidth < 992 ? 'hidden' : 'initial';
              accountDropdown.style.display = this.open ? 'block' : 'none';

              if (isWhiteNav) {
                gNav.setAttribute('data-account', this.open ? 'true' : 'false');

                if (this.open) {
                  document.body.classList.add('no-scroll');
                } else {
                  document.body.classList.remove('no-scroll');
                }
              }
            },
            clickOutsideHandler(event) {
              // Avoid closing component if user clicked on any of those elements
              const excludeElements = [
                'login-module-my-account',
                'login-module-purchase-history',
                'login-module-your-lists',
                'login-module-sign-out',
                'site-header-action-local-account',
              ];

              if (!this.open || excludeElements.includes(event.target.getAttribute('data-ui')) || accountToggleButton.contains(event.target)) return;

              if (!accountDropdown.contains(event.target)) {
                accountEventBus.$emit('closed');
              }
            },
          },
          render: (app) => app(AccountFlyout, {
            props: {
              open: data.open,
              customClasses: ['account-wrapper'],
              trapTabInsideWidget: true,
              user,
            },
            on: {
              closed() {
                accountEventBus.$emit('closed');
              },
              'on-escape': function () {
                accountEventBus.$emit('closed');
              },
            },
          }),
        });
      };

      if (accountToggleButton && navbarWrapper && isWhiteNav) {
        ['focus', 'mouseenter'].forEach((eventName) => accountToggleButton.addEventListener(eventName, () => {
          if (!isAccountMounted) {
            mountAccount();
          }
        }, {
          once: true,
        }));

        window.addEventListener('load', () => {
          if (!isAccountMounted) {
            mountAccount();
          }
        });
      }
    })
    .catch(() => {
      // eslint-disable-next-line no-new
      new Vue({
        el: '[data-ui="login-module-greeting"]',
        render(app) {
          return app(AccountLink);
        },
      });
    });
}
